import React from "react";
import Main from "./views/Main";
import "./App.css";

const App = () => {
  return <Main />;
};

export default App;
